<template>
    <div class="flex flex-col h-full">
        <geo-watcher />
        <slot  />
    </div>
</template>

<script>
    import GeoWatcher from "../components/GeoWatcher";
    export default {
        components: {
            GeoWatcher,
        },
        data() {
            return {
                menuOpen: false
            }
        },

        provide() {
            return {
                openMenu: this.openMenu,
                closeMenu: this.closeMenu
            }
        },

        methods: {
            /**
             * Method used for opening the App's over laid Menu from anywhere...
             *
             * @return {void}
             */
            openMenu() {
                this.menuOpen = true;
            },

            /**
             * Method used for closing the App's over laid Menu from anywhere...
             *
             * @return {void}
             */
            closeMenu() {
                this.menuOpen = false;
            }
        }
    }
</script>